import React from "react";
import CurrencyFormat from "react-currency-format";

const MarketStats = ({ totalMarkets, totalMarketCap, total24hVolume }) => (
  <div className="stats">
    <div>
      <h2>Total Markets</h2>
      <p>{totalMarkets}</p>
    </div>
    <div>
      <h2>Total Market Cap</h2>
      <CurrencyFormat
        value={totalMarketCap}
        decimalScale={2}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
      />
    </div>
    <div>
      <h2>Total 24h Volume:</h2>
      <CurrencyFormat
        value={total24hVolume}
        decimalScale={2}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
      />
    </div>
  </div>
);

export default MarketStats;
